package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
sealed class ResponseHeaders {
    // TODO: Keep an eye on object within sealed class for JS IR to see if issues arise
    object Invalid : ResponseHeaders()
    data class Valid(val statusCode: Int) : ResponseHeaders()

    fun <R> fold(
        onSuccess: (Value: Valid) -> R,
        onFailure: (Error: Invalid) -> R
    ): R {
        return when (this) {
            is Valid -> onSuccess(Valid(this.statusCode))
            is Invalid -> onFailure(Invalid)
        }
    }

    fun getStatusCodeOrNull(): Int? {
        return if (this is Valid) this.statusCode else null
    }

    fun getStatusCodeOrDefault(): Int {
        return if (this is Valid) this.statusCode else -1
    }
}